<template>
  <div class="accountRecharge">
    <div class="personal-box comWidth">
      <CenterNav/>
      <div class="personal-right">
        <NavT :titleS="titleS"/>
        <div class="rightmain">

            暫未開通，敬請期待

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //nav
  import NavT from '@/pages/personalPage/NavT'
  //cNav
  import CenterNav from '@/pages/personalPage/CenterNav'
  export default {
    name: 'AccountRecharge',
    components:{
      NavT,
      CenterNav
    },
    data () {
      return {
        titleS:'賬戶充值',

      }
    },
   created(){
     window.scrollTo(0,0)
   }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/personalPage/assetCenterPage/AccountRecharge.vue